export default {
  init() {
    const apiURL = "https://rufftuffdata.net:8084/webinsertmaterialscolorsview/all";
    const imageBase = "https://seats.rufftuff.com/tiles/";
    const $tilesContainer = $('#tiles');
    const urlSlug = window.location.pathname.split('/').filter(Boolean).pop();

    if (!urlSlug) {
      console.warn("No slug found in URL.");
      return;
    }

    $.ajax({
      url: apiURL,
      method: 'GET',
      dataType: 'json',
      success: function(data) {
        if (!Array.isArray(data)) {
          console.error("Unexpected response format:", data);
          return;
        }
        const matchedTiles = data
        .filter(item => item.materialProductCode === urlSlug)
        .map(item => {
          const imgSrc = `${imageBase}${urlSlug}-${item.colorProductCode}.jpg`;
          return `
          <div class="columns large-3 medium-3 small-6 fabric-swatches">
          <div class="swatch" data-open="fab-${item.colorProductCode}">
          <img src="${imgSrc}" alt="${item.color} swatch for ${urlSlug}">
          </div>
          <p>${item.color}</p>
          <div class="reveal fabrics" id="fab-${item.colorProductCode}" data-reveal>
          <img src="${imgSrc}" alt="${item.color} swatch for ${urlSlug}">
          <button class="close-button" data-close aria-label="Close modal" type="button">
          <span aria-hidden="true">&times;</span>
          </button>
          </div>
          </div>
          `;
        })
        .join('');

        // Inject the HTML
        $tilesContainer.html(matchedTiles || '<p>No matching swatches found.</p>');

        // Reinitialize Reveal on newly added modals
        $tilesContainer.find('.reveal').each(function () {
          new Foundation.Reveal($(this));
        });



      },
      error: function(jqXHR, textStatus, errorThrown) {
        console.error(`AJAX Error: ${textStatus}`, errorThrown);
        $tilesContainer.html('<p class="error">Unable to load fabric swatches at this time.</p>');
      },
    });
  },
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/taxFabTypes.js